import {Injectable} from "@angular/core";
import * as _ from "lodash";
import {PermissionInternationalReceiversService} from "@monex-sistemas/nueva-banca-digital-library";

@Injectable({providedIn: 'root'})
export class InternationalPermissionService {

    constructor(private permissionInternationalReceiversService: PermissionInternationalReceiversService) {
    }

    validatePermissonsForNomina(contractSelected, menus) {
        const hasInternationalPermission = this.permissionInternationalReceiversService.hasInternationalPermission(contractSelected);
        if (!hasInternationalPermission) {
            _.each(menus, menu => {
                // 1064, pagos
                if (menu.id == 1064) {
                    const submenus = menu.submenus;
                    //1024 internacionales
                    menu.submenus = submenus.filter(m => m.id != 1024);
                }
            })
        }
        return menus;
    }
}
